"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
var immer_1 = __importDefault(require("immer"));
var constants_1 = require("./constants");
exports.initialState = {
    showOnlyMyTeam: false,
    isImpersonating: !!localStorage.getItem('adminToken'),
    pressedKeys: [],
    advancedMode: false,
    selectMode: false,
};
// eslint-disable-next-line default-param-last
var appReducer = function (state, action) {
    if (state === void 0) { state = exports.initialState; }
    return (0, immer_1.default)(state, function (draft) {
        switch (action === null || action === void 0 ? void 0 : action.type) {
            case constants_1.SET_PRESSED_KEY:
                if (action.isDown && !draft.pressedKeys.includes(action.keyCode)) {
                    draft.pressedKeys = __spreadArray(__spreadArray([], __read(draft.pressedKeys), false), [action.keyCode], false);
                    if ([16, 17].every(function (kC) { return draft.pressedKeys.includes(kC); }) && [16, 17].some(function (kC) { return action.keyCode === kC; })) {
                        draft.advancedMode = !draft.advancedMode;
                    }
                    if ([16, 17, 83].every(function (kC) { return draft.pressedKeys.includes(kC); }) && [16, 17, 83].some(function (kC) { return action.keyCode === kC; })) {
                        draft.selectMode = !draft.selectMode;
                    }
                }
                if (!action.isDown && draft.pressedKeys.includes(action.keyCode)) {
                    draft.pressedKeys = draft.pressedKeys.filter(function (kCode) { return kCode !== action.keyCode; });
                }
                break;
            case constants_1.TOGGLE_TEAM_VIEW:
                draft.showOnlyMyTeam = !state.showOnlyMyTeam;
                break;
            case constants_1.SET_IMPERSONATING:
                draft.isImpersonating = action.isImpersonating;
                break;
            default:
                break;
        }
    });
};
exports.default = appReducer;
